<template>
  <img :src="getGif()" />
</template>

<script>
import getRandomGif from '../../libs/ui/getRandomGif';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    getGif() {
      return getRandomGif();
    },
  },
};
</script>

<style lang="scss" scoped="">
img {
  width: 350px;
  margin-top: 20px;
}
</style>
